import script from "./NewsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsModal.vue?vue&type=script&setup=true&lang=ts"

import "./NewsModal.vue?vue&type=style&index=0&id=d38047e2&lang=css"

const __exports__ = script;

export default __exports__